import { component } from 'picoapp'
import $ from 'jquery'
import 'slick-carousel'

export default component(node => {
    const slider = $('[data-usp-slider]')
    const slides = node.querySelectorAll('[data-usp-slide]').length

    slider.slick({
        slidesToShow: slides,
        autoplay: false,
        arrows: false,
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 5000,
                    fade: true
                }
            }
        ]
    })
})